<template>
	<md-card class="mt-10 upload-log-section" :class="{ 'is-open': open }">
		<md-card-actions md-alignment="left">
			<md-button class="expand-button-size" :aria-expanded="String(open)" @click="$emit('toggle')">
				<strong class="upper-word">{{ title }}</strong>
			</md-button>
		</md-card-actions>
		<!-- grid-template-rows 0fr -> 1fr animates to the content's natural height without measuring it in JS,
		     so it is safe inside the parent md-card-expand (nested md-card-expand breaks its height math). -->
		<div class="upload-log-section__body" :aria-hidden="String(!open)">
			<div class="upload-log-section__inner">
				<md-card-content class="card-content">
					<slot />
				</md-card-content>
			</div>
		</div>
	</md-card>
</template>

<script>
// Collapsible log section for Community > Data Uploads. Open state is owned by the parent
// so it can keep only one section open at a time.
export default {
	name: 'UploadLogSection',
	props: {
		title: { type: String, required: true },
		open: { type: Boolean, default: false }
	}
};
</script>

<style scoped>
/* Same duration/easing as Vue Material's md-card-expand-content. */
.upload-log-section__body {
	display: grid;
	grid-template-rows: 0fr;
	opacity: 0;
	visibility: hidden;
	transition: grid-template-rows .4s cubic-bezier(.4, 0, .2, 1), opacity .4s cubic-bezier(.4, 0, .2, 1), visibility 0s .4s;
}

.upload-log-section.is-open .upload-log-section__body {
	grid-template-rows: 1fr;
	opacity: 1;
	visibility: visible;
	transition-delay: 0s;
}

.upload-log-section__inner {
	min-height: 0;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/community/UploadLogSection.vue